/*
 * Vehicle details component
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2021 Gallagher Bassett Services, Inc.
 */

import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { Vehicle } from 'app/shared/models';

@Component({
    selector: 'reporter-vehicle-details',
    templateUrl: './vehicle-details.component.html',
    styleUrls: ['./vehicle-details.component.scss'],
    standalone: false
})
export class VehicleDetailsComponent implements OnInit {

  @Input() vehicle: Vehicle;

  constructor() { }

  ngOnInit(): void {
  }

}
